import { graphql } from 'react-relay';

import { TaskTaskHistoryPaginator_task$key } from '../../../relay/__generated__/TaskTaskHistoryPaginator_task.graphql';
import FragmentPaginator, { FragmentPaginatorProps } from '../../core/FragmentPaginator';

const TaskTaskHistoryPaginator_task = graphql`
  fragment TaskTaskHistoryPaginator_task on Task
  @argumentDefinitions(
    filters: { type: TaskHistoryFilter }
    order: { type: TaskHistoryOrder, defaultValue: { created: DESC } }
    first: { type: Int, defaultValue: 10 }
    after: { type: String }
  )
  @refetchable(queryName: "TaskTaskHistoryPaginatorRefreshQuery") {
    histories(filters: $filters, order: $order, first: $first, after: $after)
      @connection(key: "TaskTaskHistoryPaginator_task_histories") {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          type
          ...TaskHistoryDialog_taskHistory
          ...TaskHistoryTimelineItem_taskHistory
        }
      }
    }
  }
`;

type Props = {} & Omit<FragmentPaginatorProps<TaskTaskHistoryPaginator_task$key>, 'fragment'>;

const TaskTaskHistoryPaginator = ({ ...props }: Props) => (
  <FragmentPaginator fragment={TaskTaskHistoryPaginator_task} {...props} />
);

export default TaskTaskHistoryPaginator;
